import { configureStore } from '@reduxjs/toolkit';
import researchSlice from './slices/researchSlice';
import auditSlice from './slices/auditSlice';

export const store = configureStore({
  reducer: {
    research: researchSlice,
    audit: auditSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 